import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import type { LinkProps } from 'react-router-dom';

const CustomLink: FC<LinkProps> = ({ style = {}, ...props }) => (
  <Link
    style={{
      color: 'green',
      fontStyle: 'bold',
      ...style,
    }}
    {...props}
  />
);

export default CustomLink;
